import { useLocation, useNavigate } from "react-router-dom";
import WithTableView from "../../components/withTableView/withTableView";
import Pagination from "../../components/pagination/pagination";
import Content from "../../components/content/Content";
import ContentHead from "../../components/content/ContentHead";
import ContentBody from "../../components/content/ContentBody";
import styles from "./leads.module.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSearch } from "@fortawesome/free-solid-svg-icons";
import { useEffect, useState } from "react";
import axios from "axios";

const Leads = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [data, setData] = useState([]);

  useEffect(() => {
    getData();
  }, []);

  const getData = () => {
    axios({
      url: "https://backend.girnarsoft.com/api/v1/staging/home/questionnaire",
      method: "get",
    })
      .then((res) => {
        console.log(res.data);
        setData(res.data);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  return (
    <Content>
      <ContentHead
        title={"Leads"}
        showBtn1={false}
        btn1Name="btn1"
        btn1Text="Create contact"
        btn1type="filled"
        showBtn2={false}
        btn2Name="btn2"
        btn2Text="Export"
        btn2type="outlined"
        showBtn3={false}
        btn3Name="btn2"
        btn3Text="Import"
        btn3type="outlined"
      />
      <ContentBody style={{ padding: 0 }}>
        {/* <div className={styles.filter_container}>
          <div className={styles.search_section}>
            <FontAwesomeIcon icon={faSearch} />
            <input placeholder="Search name, phone, email ..." />
          </div>
        </div> */}

        <div className={styles.table_container}>
          <table className={styles.responsive_table}>
            <thead>
              <tr>
                <th>First Name</th>
                <th>Last Name</th>
                <th>Email</th>
                <th>Phone Number</th>
                <th>Industry</th>
                <th>Engagement Type</th>
                <th>Company Name</th>
                <th>Message</th>
                <th>Status</th>
                <th>Created At</th>
              </tr>
            </thead>
            <tbody>
              {data.map((val, index) => (
                <SingleRow key={index} data={val} />
              ))}
            </tbody>
          </table>
        </div>
      </ContentBody>
    </Content>
  );
};

const SingleRow = ({ data }) => {
  return (
    <tr>
      <td>{data?.firstName || "--"}</td>
      <td>{data?.lastName || "--"}</td>
      <td>{data?.emailAddress || "--"}</td>
      <td>{data?.phone || "--"}</td>
      <td>{data?.industry || "--"}</td>
      <td>{data?.engagementType || "--"}</td>
      <td>{data?.companyName || "--"}</td>
      <td>{data?.message || "--"}</td>
      <td>{data?.status || "--"}</td>
      <td>
        {data?.createdAt
          ? data?.createdAt.split("T")[0].split("-").reverse().join("/")
          : "--"}
      </td>
    </tr>
  );
};

export default Leads;
